const getters = {
  access_token: state => state.user.access_token
}
export default getters
